import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saDataAccessibilityPer5QiCellChartConfig } from '../cellChartConfigs';

interface DataAccessibilityPer5QiSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataAccessibilityPer5QiSaCell: React.FC<DataAccessibilityPer5QiSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saDataAccessibilityPer5QiCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default DataAccessibilityPer5QiSaCell;
